import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import { customerResource } from '../../system/customerManage/request';
import { pushScenarioResource, messageList } from './request';
export default {
  data() {
    return {
      form: {
        customerId: undefined,
        messageCategory: undefined,
        pushScenario: undefined,
        readingStatus: undefined,
        userName: '',
        mobile: '',
        email: ''
      },
      customersList: [],
      pushScenarioList: [],
      tabValue: 'INTERNAL_MAIL',
      columns: [{
        dataIndex: 'index',
        slots: {
          title: '序号'
        },
        align: 'center'
      }, {
        dataIndex: 'show_eventId',
        slots: {
          title: '事件ID'
        },
        align: 'center'
      }, {
        dataIndex: 'messageCategoryName',
        slots: {
          title: '消息类别'
        },
        align: 'center',
        scopedSlots: {
          customRender: 'customerRender'
        }
      }, {
        dataIndex: 'pushScenarioName',
        width: 200,
        slots: {
          title: '推送场景'
        },
        align: 'center',
        scopedSlots: {
          customRender: 'customerRender'
        }
      }, {
        dataIndex: 'customerName',
        slots: {
          title: '客户名称'
        },
        align: 'center',
        scopedSlots: {
          customRender: 'customerName'
        }
      }, {
        dataIndex: 'userName',
        slots: {
          title: '接收对象'
        },
        align: 'center',
        scopedSlots: {
          customRender: 'customerEmpty'
        }
      }, {
        dataIndex: 'createAt',
        slots: {
          title: '发送时间'
        },
        align: 'center'
      }, {
        dataIndex: 'readingStatus',
        slots: {
          title: '阅读状态'
        },
        align: 'center',
        scopedSlots: {
          customRender: 'readingStatus'
        }
      }, {
        dataIndex: 'mobile',
        slots: {
          title: '手机号'
        },
        align: 'center'
      }, {
        dataIndex: 'email',
        slots: {
          title: '邮箱'
        },
        align: 'center'
      }, {
        dataIndex: 'sendStatus',
        width: 200,
        slots: {
          title: '发送状态'
        },
        scopedSlots: {
          customRender: 'sendStatus'
        },
        align: 'center'
      }, {
        dataIndex: 'sceneConfigId',
        slots: {
          title: '模板ID'
        },
        align: 'center'
      }],
      dataSource: [],
      pagination: {
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        pageSize: 10,
        // 每页条数
        current: 1,
        showTotal: total => {
          return `${this.$t('共')} ${total} ${this.$t('条')}`;
        }
      }
    };
  },
  computed: {
    pushScenarioPlaceholder() {
      return this.form.messageCategory ? `${this.$t('请选择') + this.$t('推送场景')}` : `${this.$t('请先选择消息类别')}`;
    },
    computedColumns() {
      if (this.tabValue === 'INTERNAL_MAIL') {
        return JSON.parse(JSON.stringify(this.columns)).filter(item => item.dataIndex !== 'mobile' && item.dataIndex !== 'email');
      } else if (this.tabValue === 'NOTE') {
        return JSON.parse(JSON.stringify(this.columns)).filter(item => item.dataIndex !== 'email' && item.dataIndex !== 'readingStatus');
      } else if (this.tabValue === 'EMAIL') {
        return JSON.parse(JSON.stringify(this.columns)).filter(item => item.dataIndex !== 'mobile' && item.dataIndex !== 'readingStatus');
      }
    }
  },
  watch: {
    tabValue(val) {
      if (val === 'INTERNAL_MAIL') {
        this.form.email = '';
        this.form.mobile = '';
      } else if (val === 'NOTE') {
        this.form.email = '';
        this.form.readingStatus = undefined;
      } else if (val === 'EMAIL') {
        this.form.mobile = '';
        this.form.readingStatus = undefined;
      }
      this.searchFun();
    }
  },
  created() {
    customerResource().then(res => {
      this.customersList = [{
        id: '0',
        name: '系统管理员'
      }, ...res];
    });
    this.getList();
  },
  methods: {
    getList() {
      var _this$form$userName, _this$form$email;
      let params = {
        customerId: this.form.customerId || '',
        userName: ((_this$form$userName = this.form.userName) === null || _this$form$userName === void 0 ? void 0 : _this$form$userName.trim()) || '',
        readingStatus: this.form.readingStatus || '',
        mobile: this.form.mobile.trim() || '',
        messageCategory: this.form.messageCategory || '',
        pushScenario: this.form.pushScenario || '',
        email: ((_this$form$email = this.form.email) === null || _this$form$email === void 0 ? void 0 : _this$form$email.trim()) || '',
        page: this.pagination.current,
        pageSize: this.pagination.pageSize,
        type: this.tabValue
      };
      messageList(params).then(res => {
        this.dataSource = res.items.map(item => {
          let failureReason = item.failureReason ? JSON.parse(item.failureReason) : {
            message: ''
          };
          return {
            ...item,
            failureReason: failureReason.message
          };
        });
        this.pagination.total = Number(res.totalNum);
      });
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    },
    reset() {
      this.form = {
        customerId: undefined,
        messageCategory: undefined,
        pushScenario: undefined,
        readingStatus: undefined,
        userName: '',
        mobile: '',
        email: ''
      };
      this.pagination.current = 1;
      this.getList();
    },
    searchFun() {
      this.pagination.current = 1;
      this.getList();
    },
    flowTypeIdChange(value) {
      this.form.pushScenario = undefined;
      this.pushScenarioList = [];
      if (value) {
        pushScenarioResource({
          messageCategory: value
        }).then(res => {
          this.pushScenarioList = res;
        });
      }
    },
    handleStandardTableChange(pagination) {
      this.pagination = pagination;
      this.getList();
    }
  }
};